import Fetching from './Fetching';

export default Fetching;
